<template>
  <div class="Header">
    <div class="container">
      <div>
        <div
          class="exit"
          v-if="showExit"
          @click="$emit('exit')"
        >
          {{ exitText }}
        </div>
      </div>
      <Menu/>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/layout/menu/Menu'

export default {
  props: ['showExit', 'exitText'],
  components: { Menu }
}
</script>


<style lang="scss" scoped>
.Header {
  background-color: $dark-blue;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.exit {
  display: flex;
  align-items: center;
  color: #fff;

  &:before {
    content: '';
    display: block;
    margin-right: 5px;
    height: 15px;
    width: 15px;
    background-image: url('../../assets/images/back.svg');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
